"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compare = void 0;
var canonicaljson_1 = require("@stratumn/canonicaljson");
// note: compare could be moved to context.$compare
var compare = function (x, y) {
    // if values have diferent types return undefined
    if (typeof x !== typeof y)
        return undefined;
    // if string use localeCompare
    if (typeof x === 'string')
        return x.localeCompare(y);
    // if number compute the difference
    if (typeof x === 'number')
        return x - y;
    // if bool, cast and compute the difference
    if (typeof x === 'boolean')
        return (x ? 1 : 0) - (y ? 1 : 0);
    // finally, stringify and compare...
    return canonicaljson_1.stringify(x).localeCompare(canonicaljson_1.stringify(y));
};
exports.compare = compare;
//# sourceMappingURL=compare.js.map